<template functional>
  <!-- note functional above -->
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  // change this!
  name: 'dn-properties'
}
</script>

<style></style>
